import React from "react"
import styled from "styled-components"
import { appStrings } from "../../common/strings/app_strings"
import { makeToast } from "../../util/toast_util"

const { appName, publisher, accessType, toastMsg } = appStrings.connectedApps

export const TokenRow = ({ token, handleRevokeOAuthToken }) => {
    const { scopes, clientName, clientDescription, homepage, imageSrc, id } = token

    const revokeAuth = () => {
        const msg = toastMsg
        const ind = "warning"
        const action = {
            text: "YES",
            onClick: () => {
                handleRevokeOAuthToken(id)
            },
        }

        makeToast(msg, ind, action)
    }

    return (
        <StyledTokenRow className="token-row">
            <section>
                <div className="section-item">
                    <p className="prefix">{appName}</p>
                    <div className="client-name-wrapper">
                        <img src={imageSrc} alt="Client service icon" />
                        <p>{clientName}</p>
                    </div>
                </div>
                <div className="section-item">
                    <p className="prefix">{publisher}</p>
                    <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href={homepage}
                    >
                        <p>{clientDescription}</p>
                    </a>
                </div>
                <div className="section-item">
                    <p className="prefix">{accessType}</p>
                    <p>{scopes}</p>
                </div>
            </section>
            <div className="icon-wrapper">
                <div className="trash-button" onClick={revokeAuth}>
                    <i className="fa fa-trash-o" aria-hidden="true"></i>
                </div>
            </div>
        </StyledTokenRow>
    )
}

//styles
const StyledTokenRow = styled.div`
    display: flex;
    padding: 10px 20px;
    border-bottom: 1px solid #dde0e2;

    section {
        display: flex;
        width: 100%;

        @media (max-width: 700px) {
            flex-direction: column;
        }
        
        .section-item {
            display: flex;
            align-items: center;
            width: 33.3%;
            height: 100%;
            padding-right: 10px;

            .client-name-wrapper {
                display: flex;
                align-items: center;

                @media (max-width: 700px) {
                    flex-direction: column;
                }
            }

            @media (max-width: 700px) {
                width: 100%;
                padding-right: 10px;
                align-items: center;
                margin: 5px 0;
            }

            @media (max-width: 450px) {
                flex-direction: column;
                align-items: flex-start;
            }

            .prefix {
                display: none;
                font-size: 12px;
                font-weight: bold;
                margin-right: 10px;

                :after {
                    content: ":";
                }

                @media (max-width: 700px) {
                    display: inline-block;
                }

                @media (max-width: 450px) {
                    margin-bottom: 5px;
                }

            }
        }

        img {
            margin-right: 10px;
            width: 14px;
            height: 14px;
        }

        p {
            margin-bottom: 0;
        }
    }

    .icon-wrapper {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 15%;
        font-size: 24px;
        .trash-button {
            cursor: pointer;
        }
        @media (max-width: 700px) {
            align-items: flex-end;
        }
    }
`



// WEBPACK FOOTER //
// ./src/components/connected_apps/token_row.jsx